import { IDeleteFuncionarioTreinamentoUseCase } from "../../../presentation/useCases/delete/delete_funcionario_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFuncionarioTreinamentoUseCase
 */

export class DeleteFuncionarioTreinamentoUseCase implements IDeleteFuncionarioTreinamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteFuncionarioTreinamento(idFuncionarioTreinamento: number): Promise<void> {
    await this.repository.deleteFuncionarioTreinamento(idFuncionarioTreinamento);
  }
}